// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__9JJAX","title":"Errors_title__xa5Dp","text":"Errors_text__BhfC8","link":"Errors_link__OZ8W_"};